import { render, staticRenderFns } from "./BioanalyticalPlatform.vue?vue&type=template&id=6f5fdc84&scoped=true&lang=pug&"
import script from "./BioanalyticalPlatform.vue?vue&type=script&lang=js&"
export * from "./BioanalyticalPlatform.vue?vue&type=script&lang=js&"
import style0 from "./BioanalyticalPlatform.vue?vue&type=style&index=0&id=6f5fdc84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5fdc84",
  null
  
)

export default component.exports